// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"CircularesAss_containerPrincipal__X1Dhl","divCirculares":"CircularesAss_divCirculares__4+v7W","divAno":"CircularesAss_divAno__j-lZF"};